import * as React from 'react';

import { IGetImageSchema } from '../../repositories/special-promos/entities/schemas/GetImageSchema';
import classNames from 'classnames';

import { formatPhone } from '../../utils/formatters';
import { FragmentId, HeaderLink } from '../fragment';
import * as styles from './index.css';

interface ILink {
  title: string;
  to: FragmentId;
}

interface IHeaderProps {
  logo: IGetImageSchema;
  builderName: string;
  hash: string;
  links: ILink[];
  phone: string;
  offsetVisible?: number;
  onHashChange(hash: string): void;
}

interface IHeaderState {
  visible: boolean;
}

const DEFAULT_OFFSET = 110;

export class Header extends React.Component<IHeaderProps, IHeaderState> {
  public constructor(props: IHeaderProps) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  public componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);
  }

  public componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollHandler);
  }

  public render() {
    const { phone, builderName, logo, links, onHashChange } = this.props;
    const { visible } = this.state;

    return (
      <div className={classNames(styles['container'], visible && styles['visible'])}>
        <div className={styles['wrapper']}>
          <div className={styles['control']}>
            <div className={styles['logo-wrapper']}>
              <img src={logo.url ?? ''} alt={builderName} className={styles['logo']} />
            </div>
            <ul className={styles['links']}>
              {links.map((link, idx) => (
                <li className={styles['link-wrapper']} key={idx}>
                  <HeaderLink
                    to={link.to}
                    hash={this.props.hash}
                    className={classNames(styles['link'], 'iefix_color_hover')}
                    onHashChange={onHashChange}
                  >
                    {link.title}
                  </HeaderLink>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <a href={`tel:+${phone}`} className={classNames(styles['phone'], 'iefix_color_main')}>
              {formatPhone(phone)}
            </a>
          </div>
        </div>
      </div>
    );
  }

  private scrollHandler = () => {
    const { offsetVisible } = this.props;
    const { visible } = this.state;
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    const visibleOffset = offsetVisible || DEFAULT_OFFSET;

    if (offset > visibleOffset && !visible) {
      this.setState({
        visible: true,
      });
    }

    if (offset <= visibleOffset && visible) {
      this.setState({
        visible: false,
      });
    }
  };
}
